import { RolesApi } from '@portal/pkg-api/admin'
import { EntityTypeApi } from '@portal/pkg-api/navigator'
import { data } from '@portal/pkg-api/helpers'
import { AdminConsoleDashboardsApi } from '@portal/pkg-api/admin-console'
import type { DashboardType } from './types'

const prefix = 'admin-console.dashboards'

export const DashboardQueries = {
  /** @param type omit for all types; the API applies the filter, not the grid */
  list: (type?: DashboardType) => ({
    queryKey: [prefix, 'list', type ?? 'ALL'],
    queryFn: () => data(AdminConsoleDashboardsApi.listDashboards(type)),
  }),
  roles: () => ({
    queryKey: [prefix, 'roles'],
    queryFn: () => data(RolesApi.getRoles()),
    staleTime: Infinity,
  }),
  entityTypes: () => ({
    queryKey: [prefix, 'entityTypes'],
    queryFn: () => data(EntityTypeApi.getAdminEntityTypes()),
    staleTime: Infinity,
  }),
  detail: (id: number) => ({
    queryKey: [prefix, 'detail', id],
    queryFn: () => data(AdminConsoleDashboardsApi.getDashboard(id)),
  }),
}
